import { FormControl, FormGroup } from '@angular/forms';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FormGroupType = { [K: string]: FormControl<any> };

/**
 * Values have to match the errors of Angular form.
 */
export enum FormErrorEnum {
    AT_LEAST_ONE_TRUTHY_REQUIRED = 'atLeastOneTruthyRequired',
    CANNOT_START_WITH_NUMBER = 'cannotStartWithNumber',
    EMAIL = 'email',
    EMAIL_ALREADY_USED = 'emailAlreadyUsed',
    FORBIDDEN_WORD = 'forbiddenWord',
    INVALID_CHARACTERS = 'invalidCharacters',
    INVALID_NUMBER = 'invalidNumber',
    MAX = 'max',
    MAX_ASSIGNMENTS_LIMIT_EXCEEDED = 'maxAssignmentsLimitExceeded',
    MAX_CONTENT_SIZE = 'maxContentSize',
    MAX_FILE_SIZE = 'maxFileSize',
    MAX_IMAGE_SIZE = 'maxImageSize',
    MAX_LENGTH = 'maxlength', // match with reactive form error key
    MIN = 'min',
    MIN_LENGTH = 'minlength',
    MISMATCH = 'mismatch',
    MISSING_NUMBER = 'missingNumber',
    MISSING_SPECIAL_CHARACTER = 'missingSpecialCharacter',
    MISSING_UPPERCASE_CHARACTER = 'missingUppercaseCharacter',
    ONLY_UNACCENT_AND_ALPHANUMERIC = 'onyUnaccentAndAlphanumeric',
    PATTERN = 'pattern',
    REQUIRED = 'required',
    RESERVED_NAME = 'reservedName',
    UNSUPPORTED_FILETYPE = 'unsupportedFileType',
    VALIDATE_DATE = 'validateDate',
}

export enum SecurityFormField {
    CONFIRM_PASSWORD = 'confirmPassword',
    EMAIL = 'email',
    IDENTIFIER = 'identifier',
    PASSWORD = 'password',
}
export interface ConfirmedPasswordFormType extends FormGroupType {
    [SecurityFormField.CONFIRM_PASSWORD]: FormControl<string>;
    [SecurityFormField.PASSWORD]: FormControl<string>;
}

export interface ForgotPasswordFormType extends FormGroupType {
    [SecurityFormField.EMAIL]: FormControl<string>;
}
export interface SsoLoginFormType extends FormGroupType {
    [SecurityFormField.IDENTIFIER]: FormControl<string>;
}
export interface LoginFormType extends FormGroupType {
    [SecurityFormField.IDENTIFIER]: FormControl<string>;
    [SecurityFormField.PASSWORD]: FormControl<string>;
}
export class ConfirmedPasswordFormGroup extends FormGroup<ConfirmedPasswordFormType> {}
export class ForgotPasswordFormGroup extends FormGroup<ForgotPasswordFormType> {}
export class SsoLoginFormGroup extends FormGroup<SsoLoginFormType> {}
export class LoginFormGroup extends FormGroup<LoginFormType> {}

export enum FileTypeEnum {
    FILE = 'file',
    IMAGE = 'image',
}
